import './options.css';
import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { SquaredIcon } from '../components/squaredIcon';
import { ReactComponent as SaveSVG } from '../images/saveProceeding.svg';
import { useAuth } from '../context/context';
import { get, post } from './utils/utils';

export function Message() {
  const editableDivRef = useRef<HTMLDivElement | null>(null);
  const [message, setMessage] = useState('');
  const { user } = useAuth();

  useEffect(() => {
    get({
      url: 'message.php',
      token: user.token
    })
      .then((response) => response.data)
      .then((data) => {
        console.log(data);
        setMessage(data[0].message);
      });
  }, []);

  function putLandingMessage(event: React.SyntheticEvent<HTMLFormElement>) {
    event.preventDefault();

    const formData = new FormData();
    formData.append('message', editableDivRef.current ? editableDivRef.current.innerHTML : '');

    if (user && user.token) {
      post({
        url: 'putMessage.php',
        data: formData,
        token: user.token
      })
        .then((response) => response.data)
        .then((data) => {
          if (data.status === 'ok') {
            alert('Mensaje actualizado correctamente.');
          }
        });
    }
  }

  return (
    <div className="options-container">
      <form onSubmit={putLandingMessage} className="options-new-item">
        <strong>Mensaje</strong>
        <div
          ref={editableDivRef}
          contentEditable="true"
          style={{ border: '1px solid #ccc', padding: '10px', textAlign: 'center' }}
          dangerouslySetInnerHTML={{ __html: message }}
        />
        <div className="proceedings-submit">
          <p>Actualizar</p>
          <button type="submit">
            <SquaredIcon icon={<SaveSVG className="clickable" />} />
          </button>
        </div>
      </form>
    </div>
  );
}
